import React from "react";
import Link from "next/link";

interface Props {
  song: Song;
  index: number;
  play: (song: Song, index: number) => void;
}

export default function SongSliderItem(props: Props) {
  const colors = [229, 231, 235];
  const song = props.song || ({} as Song);

  return (
    <div
      className="relative flex flex-col justify-end w-full bg-cover rounded-lg h-44 sm:h-56"
      style={{
        backgroundImage: `url(${song.image?.url})`
      }}
    >
      <div
        onClick={() => props.play(song, props.index)}
        className="flex-1 w-full rounded-t-lg"
      ></div>
      <Link href={`/songs/${song.id}`}>
        <div
          style={{
            backdropFilter: "blur(12px)",
            backgroundColor: `rgba(${colors.join(",")}, 0.3)`
          }}
          className="px-4 py-2 rounded-b-lg 1-bg-gray-200 1-backdrop-filter backdrop-blur-md 1-bg-opacity-40 1-backdrop-saturate-100 1-backdrop-brightness-105"
        >
          <p className="text-xs font-semibold leading-normal line-clamp-1">{song.title}</p>
          <p className="text-xxs line-clamp-1">{song.author}</p>
        </div>
      </Link>
    </div>
  );
}
